export default "__VITE_PUBLIC_ASSET__e1646df3__"